<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
	<div class="sysConfigList">
		<!--筛选条-->
    <el-form class="z-plate__operation-bar" inline @submit.native.prevent>
			<div style="text-align: right;padding: 0 10px 10px;float: right;">
         <el-button @click="handleAdd()" type="primary" size="small" id="sysConfigAdd">新增配置</el-button>
      </div>
    </el-form>
    <section class="z-plate__container">
      <div class="content">
        <el-table :data="tableDatas" style="width: 100%;overflow: auto;" height="calc(100% - 30px)" border v-loading="loading">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="configName" label="名称" ></el-table-column>
          <!--<el-table-column prop="configType" label="配置类型" width="100%"></el-table-column>-->
          <el-table-column prop="configKey" label="配置key" ></el-table-column>
          <el-table-column prop="configValue" label="值value" >
            <template slot-scope="scope">
              <template v-if="scope.row.configType === 'SELECT'">
                <el-select v-model="scope.row.configValue" placeholder="请选择"
                           @change="optionChange(scope.row)" id="scope.row.configId+'sysconfigSelect'">
                  <el-option v-for="(item,index) in scope.row.configOptions.split(',')" :key="index" :value="item">
                    <span style="float: left">{{ item }}</span>
                  </el-option>
                </el-select>
              </template>
              <template v-else-if="scope.row.configType === 'RADIO'">
                <el-radio-group v-model="scope.row.configValue" id="scope.row.configId+'sysconfigRadio'">
                    <el-radio v-for="item in scope.row.configOptions.split(',')"
                              :key="item" :label="item" @change="optionChange(scope.row)"></el-radio>
                </el-radio-group>
              </template>
              <template v-else-if="scope.row.configType === 'CHECKBOX'">
                <el-checkbox-group v-model="scope.row.configValue" id="scope.row.configId+'sysconfigCheckbox'">
                  <el-checkbox v-for="item in scope.row.configOptions.split(',')"
                               :key="item" :label="item" @change="optionChange(scope.row)"></el-checkbox>
                </el-checkbox-group>
              </template>
              <template v-else>
                <el-input v-model="scope.row.configValue" placeholder="请输入内容" @blur="optionChange(scope.row)"
                          id="scope.row.configId+'sysconfigInput'"></el-input>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button :id="scope.row.configId+'sysConfigEdit'" @click="handleEdit(scope.$index, scope.row)" type="primary" size="small">编辑</el-button>
              <el-button :id="scope.row.configId+'sysConfigDel'" @click="handleDelete(scope.$index, scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>

    <!--编辑-->
    <el-dialog title="编辑配置信息" :visible.sync="dialogFormVisible" @close="refresh" :close-on-click-modal="false">
      <el-form :model="selectTable" :rules="rules" ref="selectTable" label-width="100px">
        <el-form-item label="名称" prop="configName">
          <el-input v-model="selectTable.configName" id="sysConfigName"></el-input>
        </el-form-item>
        <el-form-item label="配置类型" prop="configType">
          <el-select v-model="selectTable.configType" clearable placeholder="请选择" id="sysConfigType">
            <el-option v-for="item in options" :key="item.dictId"
                       :label="item.dictCode" :value="item.dictCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配置key" prop="configKey">
          <el-input v-model="selectTable.configKey" id="sysConfigKey"></el-input>
        </el-form-item>
        <el-form-item label="值value" prop="configValue">
          <el-input v-model="selectTable.configValue" id="sysConfigValue"></el-input>
        </el-form-item>
        <el-form-item label="可选值" prop="configOptions">
          <el-input v-model="selectTable.configOptions" id="sysConfigOptions"></el-input>
        </el-form-item>
        <el-form-item label="输入类型限制" prop="regex">
          <el-input v-model="selectTable.regex" placeholder="请输入正则表达式" id="sysConfigRegex"></el-input>
        </el-form-item>
        <el-form-item label="错误提示信息" prop="regexMessage">
          <el-input v-model="selectTable.regexMessage" placeholder="请输入错误提示信息,20字以内" maxlength="20"
                    id="sysConfigRegexMessage"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="configSort">
          <el-input v-model="selectTable.configSort" id="sysConfigSort"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="selectTable.configDes"
                    maxlength="100" placeholder="100字以内" id="sysConfigDes"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button id="sysconfigEditCancel" @click="dialogFormVisible = false">取 消</el-button>
        <el-button id="sysconfigEditSubmit" type="primary" @click="submitForm('selectTable','update')">确 定</el-button>
      </div>
    </el-dialog>

    <!--新增-->
    <el-dialog title="新增配置" :visible.sync="dialogAddFormVisible" @close="resetForm('ruleForm')" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="名称" prop="configName">
          <el-input v-model="ruleForm.configName" placeholder="请输入配置名称" id="sysConfigAddName"></el-input>
        </el-form-item>
        <el-form-item label="配置类型" prop="configType">
          <el-select v-model="ruleForm.configType" clearable placeholder="请选择配置类型" id="sysConfigAddType">
            <el-option v-for="item in options" :key="item.dictId" :label="item.dictCode"
                       :value="item.dictCode" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="输入类型限制" prop="regex">
          <el-input v-model="ruleForm.regex" placeholder="请输入正则表达式" id="sysConfigAddRegex"></el-input>
        </el-form-item>
        <el-form-item label="错误提示信息" prop="regexMessage">
          <el-input v-model="ruleForm.regexMessage" placeholder="请输入错误提示信息,20字以内" maxlength="20" id="sysConfigAddRegexMessage"></el-input>
        </el-form-item>
        <el-form-item label="配置Key" prop="configKey">
          <el-input v-model="ruleForm.configKey" placeholder="请输入配置Key" id="sysConfigAddKey"></el-input>
        </el-form-item>
        <el-form-item label="值Value" prop="configValue">
          <el-input v-model="ruleForm.configValue" placeholder="请输入值Value" id="sysConfigAddValue"></el-input>
        </el-form-item>
        <el-form-item label="可选值" prop="configOptions">
          <el-input v-model="ruleForm.configOptions" placeholder="如有多个值，请输入" id="sysConfigAddOptions"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="configSort">
          <el-input v-model="ruleForm.configSort" placeholder="请输入排序号" id="sysConfigAddSort"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="configDes">
          <el-input type="textarea" v-model="ruleForm.configDes"
                    maxlength="100" placeholder="100字以内" id="sysConfigAddDes"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button id="sysConfigAddSubmit" type="primary" @click="submitForm('ruleForm','add')">立刻添加</el-button>
          <el-button id="sysConfigAddReset" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";
export default {
  name: 'sysConfigList',
  data () {
    let validateSort = (rule, value, callback) => {
      /*var str=/^\d+$/g;*/
      var _regex = this.ruleForm.regex;
      if(_regex !== '' && _regex !== null & _regex !== undefined){
        this.regex = _regex;
        this.regexMessage = this.ruleForm.regexMessage;
      }
//    console.log("this.regex：" + this.regex);
      if(this.regex !== '' && this.regex !== null && this.regex !== undefined){
        const str = new RegExp(this.regex);
        const flag = str.test(value);
        if (flag) {
          callback();
        } else {
          callback(new Error(this.regexMessage));
        }
      }else {
        callback();
      }
    };
    return {
      tableDatas: [],
      selectTable: {},
      options: [
        {dictId:'125',dictCode:'TEXT'},
        {dictId:'126',dictCode:'RADIO'},
        {dictId:'127',dictCode:'CHECKBOX'},
        {dictId:'128',dictCode:'SELECT'},
        {dictId:'129',dictCode:'TEXTAREA'}
      ],
      dialogFormVisible: false,
      dialogTableVisible: false,
      dialogAddFormVisible: false,
      dictIDatas:[],
      configOptions:[],
      regex:'',
      regexMessage:'',
      loading:true,
      ruleForm: {
        configId:'',
        configName: '',
        configType: '',
        configKey: '',
        configValue: '',
        configOptions: '',
        regex:'',
        regexMessage:'',
        configSort: 0,
        configDes: ''
      },
      rules: {
        configName: [
          { required: true, message: '请输入配置名称', trigger: 'blur' },
          { max: 200, message: '长度在 200 个字符以内', trigger: 'blur' }
        ],
        configType: [
          { required: true, message: '请输入配置类型', trigger: 'blur' },
        ],
        configValue: [
          { required: true, message: '请输入配置值', trigger: 'blur' },
          {validator: validateSort}
        ],
        configKey: [
          { required: true, message: '请输入配置标识(字符唯一)', trigger: 'blur' }
        ],
        configSort: [
          { required: true, message: '请输入配置排序号', trigger: 'blur' },
          {validator: validateSort}
        ],
        regexMessage:[
          {  max: 20, message: '长度在 20 个字符以内', trigger: 'blur' }
        ],
        configDes: [
          {  max: 100, message: '长度在 100 个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  components:{
  },
	props: {},
	created() {
	},
	mounted() {
    this.querySysConfigList();
	},
	methods: {
	  //系统配置列表
    querySysConfigList() {
      var _this = this;
      _this.$post('sys/findSysConfigList',{}).then(function(response){
        if (response.code == '1'){
          _this.loading = false;
          _this.tableDatas = response.result.sysConfigList;
          for(var i=0;i<_this.tableDatas.length;i++){
            if(_this.tableDatas[i].configType === 'CHECKBOX'){
              _this.tableDatas[i].configValue = _this.tableDatas[i].configValue.split(',');
            }
          }
        }
      }).catch(function (error) {
//      console.log(error);
      })
    },
    //查看该字典组下的字典项列表
    handleClick(row){

    },
    //编辑窗口
    handleEdit(index, row) {
      this.selectTable = row;
      this.dialogFormVisible = true;
      this.regex = row.regex;
      this.regexMessage = row.regexMessage;
    },
    //增加弹窗
    handleAdd: function () {
      this.dialogAddFormVisible = true;
    },
    //验证表单
    submitForm(formName,type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(type === 'update'){
            this.updateSysConfig();
          }else if(type === 'add'){
            this.addSysConfig();
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.regex = '';
      this.regexMessage = '';
    },
    //请求后台增加
    addSysConfig:function () {
      var _this = this;
      _this.$post('sys/addSysConfig',{
        configName: _this.ruleForm.configName,
        configType: _this.ruleForm.configType,
        configKey: _this.ruleForm.configKey,
        regex: _this.ruleForm.regex,
        regexMessage: _this.ruleForm.regexMessage,
        configValue: _this.ruleForm.configValue,
        configOptions: _this.ruleForm.configOptions,
        configSort: _this.ruleForm.configSort,
        configDes: _this.ruleForm.configDes
      }).then(function (response) {
        if (response.code == '1') {
          _this.dialogAddFormVisible = false;
          _this.$message({
            type: 'success',
            message:  '添加配置成功'
          });
          _this.querySysConfigList();
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
        _this.regex = '';
        _this.regexMessage = '';
      }).catch(function (error) {
        _this.regex = '';
        _this.regexMessage = '';
//      console.log(error);
      })
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var _this = this;
        _this.$post('sys/deleteSysConfig',{
          configId: row.configId
        }).then(function(response){
          if (response.code == '1') {
            var flag = response.result.deleteCode;
            _this.$message({
              type: flag ? 'success':'warning',
              message: flag ? '删除成功':'删除失败'
            });
            _this.querySysConfigList();
          }else{
            _this.$message({
              type: 'error',
              message: response.msg
            });
          }
        }).catch(function (error) {
//        console.log(error);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //更新
    updateSysConfig(){
      const value = this.selectTable.configValue;
      if(value === '' || value === null || value === undefined){
        this.$message({
          type: 'error',
          message: 'configValue值 不能为空'
        });
        return;
      }
      if(this.regex !== '' && this.regex !== null && this.regex !== undefined){
        var str = new RegExp(this.regex);
        const flag = str.test(value);
        if (!flag) {
          this.$message({
            type: 'error',
            message: this.regexMessage
          });
          this.regex = '';
          this.regexMessage = '';
          return;
        }
      }

      var _this = this;
      _this.$post('sys/editSysConfig',{
        configId: _this.selectTable.configId,
        configName: _this.selectTable.configName,
        configType: _this.selectTable.configType,
        configKey: _this.selectTable.configKey,
        configValue: _this.selectTable.configValue,
        configOptions: _this.selectTable.configOptions,
        configSort: (_this.selectTable.configSort == null ||
          _this.selectTable.configSort == '') ? 0 : _this.selectTable.configSort,
        configDes: _this.selectTable.configDes
      }).then(function (response) {
        if (response.code == '1') {
          _this.dialogFormVisible = false;
          _this.$message({
            type: 'success',
            message: '更新信息成功'
          });
          _this.regex = '';
          _this.regexMessage = '';
          _this.querySysConfigList();
        }else{
          _this.$message({
            type: 'error',
            message: response.msg
          });
        }
      }).catch(function (error) {
//      console.log(error);
      })
    },
    //日期处理
    dateFormat:function(row, column){
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    //清空数据
    cleanData(){
      this.dictIDatas = [];
    },
    //编辑框关闭跳转
    refresh(){
      this.regex = '';
      this.regexMessage = '';
      this.querySysConfigList();
    },
    handleInfo:function (row) {
      this.selectTable = row;
      this.dialogFormVisible = true;
    },
    //更新
    optionChange(row){
      this.selectTable = row;
      this.regex = row.regex;
      this.regexMessage = row.regexMessage;
      this.updateSysConfig();
    }

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.sysConfigList,.z-plate__container,.content{
		height: 100%;
	}
</style>
